import { render, staticRenderFns } from "./trace-detail.vue?vue&type=template&id=1d20dc83&scoped=true"
import script from "./trace-detail.vue?vue&type=script&lang=js"
export * from "./trace-detail.vue?vue&type=script&lang=js"
import style0 from "./trace-detail.vue?vue&type=style&index=0&id=1d20dc83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20dc83",
  null
  
)

export default component.exports